import { Grid as MuiGrid, List as MuiList } from '@mui/material'
import { styled, css } from '@mui/system'
import { FixedSizeList } from 'react-window'
import Button from '@bluheadless/ui/src/molecules/button'

const shouldForwardProp = (prop) =>
	!['availableInStore', 'maxHeight', 'minHeight', 'stores', 'useVirtualList', 'variant'].includes(prop)

const AvailabilityInStore = styled(MuiGrid, { shouldForwardProp })`
	margin: ${({ theme }) => theme.spacing(0, 0, 3)};
	> p {
		display: flex;
		align-items: center;
		:before {
			content: '';
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background-color: ${({ availableInStore, theme }) =>
				availableInStore ? theme.palette.success.main : theme.palette.error.main};
			margin-right: ${({ theme }) => theme.spacing(1)};
		}
	}
`

const AddressWrapper = styled(MuiGrid)`
	margin: ${({ theme }) => theme.spacing(2, 0, 3)};
	> div:first-of-type {
		max-width: 100%;
	}
`

const Distance = styled(MuiGrid)`
	padding-left: ${({ theme }) => theme.spacing(2)};
`

const List = styled(MuiList, { shouldForwardProp })`
	overflow-y: auto;
	padding: ${({ theme }) => theme.spacing(0, 0, '15%', 0)};
	> div:last-of-type {
		border-bottom: none;
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(0, 5, '15%', 0)};
	}
`
const ListWrapper = styled('div', { shouldForwardProp })`
	${({ theme, variant }) =>
		variant !== 'columns' &&
		`
		height: calc(var(--vh, 1vh) * 100);
		${theme.breakpoints.up('lg')} {
			min-height: unset;
		}
	`}
	${({ maxHeight, minHeight, theme, variant }) =>
		`
	${theme.scrollbar};
	max-height: ${maxHeight?.mobile || maxHeight};
	min-height: ${variant !== 'columns' ? `calc(${minHeight}px - ${theme.spacing(4)})` : `100%`};
	padding: 0;
	${theme.breakpoints.up('lg')} {
		max-height: ${maxHeight?.desktop || maxHeight};
	}
`}
`

const PickUpInStoreAction = styled(MuiGrid)`
	text-align: center;
	margin-top: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		text-align: right;
		margin-left: auto;
	}
`

const commonRootStyles = (theme) => css`
	position: relative;
	background-color: ${theme.palette.white.main};
	padding: 0;
	margin: 0 var(--spacing-3);
	.stores-list {
		> div > div:last-of-type {
			border-bottom: none;
		}
	}
	${theme.breakpoints.up('md')} {
		border: 1px solid var(--color-primary);
		border-radius: ${theme.shape.borderRadius}px;
		padding: var(--spacing-3);
		margin-bottom: 20px;
		padding-bottom: 60px;
	}
`

const Root = styled('div', {
	shouldForwardProp,
})`
	${({ theme }) => commonRootStyles(theme)};
	${({ theme, useVirtualList }) => `
		${!useVirtualList ? `height: 100%;` : ''}
		overflow-y: hidden;
		> p:first-of-type {
			padding-bottom: ${useVirtualList ? 0 : theme.spacing(2.5)};
		}
	`}
`

const RootNoStores = styled('div', { shouldForwardProp })`
	${({ theme }) => commonRootStyles(theme)};
	padding: ${({ theme }) => theme.spacing(3)};
`

const RootListItem = styled(MuiGrid, { shouldForwardProp })`
	padding: ${({ theme, useVirtualList }) => (useVirtualList ? theme.spacing(2, 0) : theme.spacing(4, 0, 3))};
	${({ theme }) => `
		${theme.breakpoints.up('lg')} {
			border-bottom: 1px solid var(--color-grey60);
		}
	`}
`

const VirtualList = styled(FixedSizeList)`
	${({ theme }) => theme.scrollbar};
	margin-top: 30px;
`

const ShowDetailsAction = styled(MuiGrid)`
	margin-bottom: ${({ theme }) => theme.spacing(2)};
`

const ButtonStyled = styled(Button)`
	&:hover {
		color: var(--color-primary);
		border-bottom: 1px solid var(--color-primary);
	}
`

export {
	ButtonStyled,
	AvailabilityInStore,
	AddressWrapper,
	Distance,
	List,
	ListWrapper,
	PickUpInStoreAction,
	Root,
	RootListItem,
	RootNoStores,
	VirtualList,
	ShowDetailsAction,
}
